<template>
    <div>
    <v-app-bar
      app
      color="secondary"
    >
        <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
        <router-link to="/"><v-img
        class="mx-2"
        :src="require('../assets/logo.png')"
        max-height="40"
        max-width="40"
        contain
      ></v-img></router-link>
        <v-toolbar-title>Støtteforeningen #HvorErDerEnVoksen</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-toolbar-items>
              <!-- <v-btn v-if="!$store.state.isUserLoggedIn" dark color="cyan" to="register">
                  Signup
              </v-btn>
          <v-btn v-if="!$store.state.isUserLoggedIn" icon to="login">
              <v-icon>mdi-login</v-icon>
          </v-btn>
          <v-btn v-if="$store.state.isUserLoggedIn" icon>
            <v-icon>mdi-logout</v-icon>
          </v-btn> -->
        </v-toolbar-items>
<!--
      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->

    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: 'page-header'
}
</script>

<style scoped>

</style>
